export default "__VITE_ASSET__b_uIJhAO__"